import { applicationModuleRegistry } from '@philips-internal/oswald-ui-foundation';

import { MessageRoutesApplication } from '../../constants';

function setupMessage(): void {
  applicationModuleRegistry.register({
    closeable: true,
    entry: 'message',
    id: 'message',
    name: 'modules.messages',
    route: MessageRoutesApplication.MESSAGE_LIST,
  });
}

export {
  setupMessage,
};
